import main from './main';
import slider from './slider';
import product from './product';
import post from './post';

const init = () => {
    main();
    slider();
    product();
    post();
};

export default init;
